import React from 'react';
import { format } from 'date-fns';
import Icon from '../../../components/AppIcon';

const NotificationHistoryItem = ({ notification, onMarkAsRead }) => {
  const getNotificationIcon = (method) => {
    switch (method) {
      case 'email':
        return 'Mail';
      case 'push':
        return 'Smartphone';
      case 'in_app':
      default:
        return 'Bell';
    }
  };

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'MMM d, yyyy h:mm a');
    } catch {
      return dateString;
    }
  };

  return (
    <div className={`bg-card rounded-lg border border-border p-16 md:p-20 hover:shadow-elevation-2 transition-smooth ${
      !notification?.read ? 'border-l-4 border-l-primary' : ''
    }`}>
      <div className="flex items-start gap-12">
        {/* Icon */}
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
          !notification?.read ? 'bg-primary/10' : 'bg-muted'
        }`}>
          <Icon
            name={getNotificationIcon(notification?.notificationMethod)}
            size={18}
            color={!notification?.read ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
          />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-12 mb-4">
            <h4 className={`font-semibold text-sm ${
              !notification?.read ? 'text-foreground' : 'text-muted-foreground'
            }`}>
              {notification?.title}
            </h4>
            {!notification?.read && (
              <span className="w-2 h-2 bg-primary rounded-full flex-shrink-0 mt-6"></span>
            )}
          </div>
          <p className="text-sm text-muted-foreground mb-8">{notification?.message}</p>
          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">
              {formatDate(notification?.sentAt)}
            </span>
            {!notification?.read && (
              <button
                onClick={onMarkAsRead}
                className="text-xs text-primary hover:underline font-medium min-h-[44px] px-8"
              >
                Mark as read
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationHistoryItem;